import { ReactNode } from 'react'
import { isNil } from 'lodash'
import { UploadDocumentType } from '@/constants/businessConstants'

import { TypographyStyles, TextColors } from '@/styles'
import { Popup, Text } from '@/ui'

interface IPracticeProfileEntry {
  label: string
  value?: string | number | null
  popupContent?: ReactNode
  documentType?: UploadDocumentType
  taxYear?: string
}

export const PracticeProfileEntry = ({
  label,
  value,
  popupContent,
}: IPracticeProfileEntry) => {
  return (
    <div className="flex flex-col md:flex-row text-left gap-2 mb-4 items-start md:items-center">
      <Text className="w-full md:w-3/10" variant={TypographyStyles.LABEL_SM}>
        {label}
        {popupContent && <Popup content={popupContent} />}
      </Text>

      <div className="w-full md:w-7/10">
        {!isNil(value) && (
          <Text variant={TypographyStyles.BODY_SM} color={TextColors.MUTED}>
            {value}
          </Text>
        )}
      </div>
    </div>
  )
}
